//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { ICuralateStore } from '@models/AppState';

export const getCurrentStartDate = (state: ICuralateStore) =>
  state.pinterest.schedule.startDate;
